/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ConfigurazioneMailDTO { 
    mailHost?: string;
    mailPort?: string;
    mailSslEnabled?: boolean;
    mailTslEnabled?: boolean;
    mailFrom?: string;
    mailUsername?: string;
    mailPassword?: string;
}

